import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d37ec8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings-sidebar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.93198 14.2473H15.75V15.7473H2.25V12.5653L9.67462 5.14073L12.8566 8.32267L6.93198 14.2473ZM10.7353 4.08007L12.3263 2.48908C12.6192 2.19619 13.094 2.19619 13.3869 2.48908L15.5083 4.6104C15.8012 4.90329 15.8012 5.37817 15.5083 5.67106L13.9172 7.26205L10.7353 4.08007Z",
    fill: "white"
  })
], -1))
const _hoisted_3 = { class: "settings-sidebar_menu" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "item_icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12 14V22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM14.5946 18.8115C14.5327 18.5511 14.5 18.2794 14.5 18C14.5 17.7207 14.5327 17.449 14.5945 17.1886L13.6029 16.6161L14.6029 14.884L15.5952 15.4569C15.9883 15.0851 16.4676 14.8034 17 14.6449V13.5H19V14.6449C19.5324 14.8034 20.0116 15.0851 20.4047 15.4569L21.3971 14.8839L22.3972 16.616L21.4055 17.1885C21.4673 17.449 21.5 17.7207 21.5 18C21.5 18.2793 21.4673 18.551 21.4055 18.8114L22.3972 19.3839L21.3972 21.116L20.4048 20.543C20.0117 20.9149 19.5325 21.1966 19.0001 21.355V22.5H17.0001V21.3551C16.4677 21.1967 15.9884 20.915 15.5953 20.5431L14.603 21.1161L13.6029 19.384L14.5946 18.8115ZM18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17Z",
      fill: "#3C92FE"
    })
  ])
], -1))
const _hoisted_5 = { class: "item_title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "item_icon" }, null, -1))
const _hoisted_7 = { class: "item_title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "item_icon" }, null, -1))
const _hoisted_9 = { class: "item_title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "item_icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.04932 13.0001H7.52725C7.70624 16.2689 8.7574 19.3054 10.452 21.881C5.98761 21.1872 2.5001 17.5403 2.04932 13.0001ZM2.04932 11.0001C2.5001 6.4598 5.98761 2.81288 10.452 2.11914C8.7574 4.69468 7.70624 7.73123 7.52725 11.0001H2.04932ZM21.9506 11.0001H16.4726C16.2936 7.73123 15.2425 4.69468 13.5479 2.11914C18.0123 2.81288 21.4998 6.4598 21.9506 11.0001ZM21.9506 13.0001C21.4998 17.5403 18.0123 21.1872 13.5479 21.881C15.2425 19.3054 16.2936 16.2689 16.4726 13.0001H21.9506ZM9.53068 13.0001H14.4692C14.2976 15.7829 13.4146 18.3733 11.9999 20.5916C10.5852 18.3733 9.70229 15.7829 9.53068 13.0001ZM9.53068 11.0001C9.70229 8.21722 10.5852 5.62684 11.9999 3.40853C13.4146 5.62684 14.2976 8.21722 14.4692 11.0001H9.53068Z",
      fill: "#CFCFCF"
    })
  ])
], -1))
const _hoisted_11 = { class: "item_title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "item_icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M22 13.3414C21.3744 13.1203 20.7013 13 20 13C16.6863 13 14 15.6863 14 19C14 19.7013 14.1203 20.3744 14.3414 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V13.3414ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829ZM17.05 19.5485C17.0172 19.3706 17 19.1873 17 19C17 18.8127 17.0172 18.6294 17.05 18.4515L16.0359 17.866L17.0359 16.134L18.0505 16.7197C18.3278 16.4824 18.6489 16.2948 19 16.1707V15H21V16.1707C21.3511 16.2948 21.6722 16.4824 21.9495 16.7197L22.9641 16.134L23.9641 17.866L22.95 18.4515C22.9828 18.6294 23 18.8127 23 19C23 19.1873 22.9828 19.3706 22.95 19.5485L23.9641 20.134L22.9641 21.866L21.9495 21.2803C21.6722 21.5176 21.3511 21.7052 21 21.8293V23H19V21.8293C18.6489 21.7052 18.3278 21.5176 18.0505 21.2803L17.0359 21.866L16.0359 20.134L17.05 19.5485ZM20 20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18C19.4477 18 19 18.4477 19 19C19 19.5523 19.4477 20 20 20Z",
      fill: "#CFCFCF"
    })
  ])
], -1))
const _hoisted_13 = { class: "item_title" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "item_icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M22 20H2V18H3V11.0314C3 6.04348 7.02944 2 12 2C16.9706 2 21 6.04348 21 11.0314V18H22V20ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z",
      fill: "#CFCFCF"
    })
  ])
], -1))
const _hoisted_15 = { class: "item_title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "item_icon" }, null, -1))
const _hoisted_17 = { class: "item_title" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "item_icon" }, null, -1))
const _hoisted_19 = { class: "item_title" }
const _hoisted_20 = {
  key: 2,
  class: "settings-sidebar_item item -lang"
}
const _hoisted_21 = { class: "asSettings_label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_avatar = _resolveComponent("avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_lang = _resolveComponent("lang")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: { name: 'userEdit' },
      class: "settings-sidebar_avatar"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_avatar, {
          preview: _ctx.user.avatar
        }, {
          icon: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["preview"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: { name: 'userEdit' },
        class: "settings-sidebar_item item"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('myProfile')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: { name: 'subscriptions' },
        class: "settings-sidebar_item item"
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('Subscriptions')), 1)
        ]),
        _: 1
      }),
      (_ctx.isShowInstallments)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: 'installments' },
            class: "settings-sidebar_item item"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('installments.shortTitle')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        to: { name: 'socialNetworks' },
        class: "settings-sidebar_item item"
      }, {
        default: _withCtx(() => [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('linkSocialNetworks')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: { name: 'settingsNotifications' },
        class: "settings-sidebar_item item"
      }, {
        default: _withCtx(() => [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('settingNotifications')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: { name: 'settingsReminders' },
        class: "settings-sidebar_item item"
      }, {
        default: _withCtx(() => [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('reminderTraining')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: { name: 'userPassword' },
        class: "settings-sidebar_item item"
      }, {
        default: _withCtx(() => [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('changePassword')), 1)
        ]),
        _: 1
      }),
      (_ctx.isShowCookie)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: { name: 'settingsCookiePolicy' },
            class: "settings-sidebar_item item"
          }, {
            default: _withCtx(() => [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('cookie.policy')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.canChangeLang)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(_component_lang, null, {
              label: _withCtx(() => [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('changeLang')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}